import { Col, Container, Row } from "react-bootstrap";
import "../../sass/layout/programListContainer/programListContainer.css";
import { useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Mixpanel } from "../../utils/mixpanelIntegration";
import UserService from "../../services/api/UserService";

const ProgramPreviewList = ({ border, program, preferRetireeImage = false }) => {
  const tokenMedia = useSelector((state) => state.homeReducer.tokenMedia);
  const location = useSelector((state) => state.homeReducer.location?.data);

  const imageUrl =
    preferRetireeImage && program?.retireeImage
      ? program.retireeImage
      : program?.image;

  return (
    <Container fluid className="no-border-container">
      <Row className={border ? "program-item-border" : "program-item"}>
        <img
          style={{
            width: "15em",
            objectFit: "contain",
            padding: "0rem 1.5rem",
          }}
          alt="program"
          src={imageUrl + "?" + tokenMedia}
        />
        <Col className="text">
          <h4>{program?.title}</h4>
          <ReactMarkdown 
            remarkPlugins={[remarkGfm]} 
            components={{
              table: ({node, ...props}) => <table className="table table-bordered table-striped" {...props} />
            }}
            children={program?.description} 
          />
          <a
        onClick={() => {
            Mixpanel.track("Programs.programClicked", {
              isLogged: UserService.isLoggedIn(),
              programName: program.name,
              programLink: program.url,
              locationName: location?.name,
            })
          }}
          href={program?.link.includes("http") ? program?.link : "https://" + program?.link} target="_blank" rel="noreferrer">

        
            See more
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default ProgramPreviewList;
